import React from 'react';

// React 19 natively hoists <title>, <meta>, and <link> tags to <head>.
// JSON-LD is rendered inline (valid for search engines anywhere in the document).
const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://nivadigital.io';

const SEO = ({
  title = 'AI-Enabled Teams | NIVA Digital AI',
  description = 'Build, Operate, Transfer. Access world-class AI-enabled teams for infrastructure, DevOps, CloudOps, and GCC services.',
  keywords = 'AI-enabled teams, GCC consulting, cloud services, DevOps, CloudOps',
  canonical = `${BASE_URL}/`,
  ogImage = `${BASE_URL}/niva-logo.jpg`,
  ogType = 'website',
  structuredData = null,
}) => {
  return (
    <>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />

      {/* Structured Data / JSON-LD */}
      {structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      )}
    </>
  );
};

export default SEO;
